/* istanbul ignore file */
import { faUserCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import MUITypography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import samsonLogoLarge from 'src/assets/logo-default.svg';
import { StyledLogo } from 'src/templates/UnauthenticatedTemplate';

export default function CreateAccountSuccess({ logoUrl }: { logoUrl?: string }) {
  const { t } = useTranslation('authentication');
  return (
    <CreateAccountSuccessContainer>
      <StyledLogo src={logoUrl || samsonLogoLarge} />
      <CreateAccountSuccessTitle>{t('register.created.thankyouYourAccountHasBeenCreated')}</CreateAccountSuccessTitle>
      <CreateAccountSuccessIcon icon={faUserCheck} />
      <CreateAccountSuccessBodyBold>{t('register.created.pleaseCheckYourInbox')}</CreateAccountSuccessBodyBold>
      <CreateAccountSuccessBody>{t('register.created.activateEmailLinkSentToEmail')}</CreateAccountSuccessBody>
    </CreateAccountSuccessContainer>
  );
}

const CreateAccountSuccessContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.palette.brand.contrastText};
`;

const CreateAccountSuccessTitle = styled(MUITypography)`
  font-size: 2.125rem;
  margin: 1.25rem 0;
`;

const CreateAccountSuccessIcon = styled(FontAwesomeIcon)`
  height: 90px;
  margin: 1.25rem 0;
`;

const CreateAccountSuccessBodyBold = styled(MUITypography)`
  font-size: 1.25rem;
  width: 70%;
  margin: 1.25rem 0;
  font-weight: bold;
`;

const CreateAccountSuccessBody = styled(MUITypography)`
  font-size: 1rem;
  width: 70%;
  margin: 1.25rem 0;
`;
